export default __webpack_public_path__ + "static/media/add-round.9aae028c.svg";